import React from "react";
import BackIcon from "../../Assets/Icons/BackIcon";
import "./style.css";
import bowling_image1 from "../../Assets/Images/bowling_image1.png";
import bowling_image2 from "../../Assets/Images/bowling_image2.png";
import bowling_image3 from "../../Assets/Images/bowling_image3.png";
import bowling_image4 from "../../Assets/Images/bowling_image4.png";
import Bowling21 from "../../Assets/Images/Bowling21.png";
import Bowling22 from "../../Assets/Images/Bowling22.png";
import Bowling23 from "../../Assets/Images/Bowling23.png";
import Bowling24 from "../../Assets/Images/Bowling24.png";
import Bowling25 from "../../Assets/Images/Bowling25.png";
import bowling11 from "../../Assets/Images/Bowling11.png";
import bowling12 from "../../Assets/Images/Bowling12.png";
import bowling13 from "../../Assets/Images/Bowling13.png";

import bowling_section_image from "../../Assets/Images/bowl_bg.png";

import stock_photo from "../../Assets/Images/stock_photo.png";
import dribbling from "../../Assets/Images/dribbling.png";
import shooting from "../../Assets/Images/shooting.png";
import passing from "../../Assets/Images/passing.png";
import defense from "../../Assets/Images/defense.png";
import rebounding from "../../Assets/Images/rebounding.png";
import bowling_trainer1 from "../../Assets/Images/basketball_trainer1.png";
import bowling_trainer2 from "../../Assets/Images/basketball_trainer2.png";
import bowling_trainer3 from "../../Assets/Images/basketball_trainer3.png";
import { useNavigate } from "react-router-dom";
import SEO from "../../Components/SEO";

export default function Bowling() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleSubmit = (type) => {
    if (user && user.is_self_pay === false && type) {
      navigate(`/list-of-sports?type=${type}`);
    } else if (user && user.is_self_pay === true && type) {
      navigate(`/session-sports?type=${type}`);
    } else {
      navigate(`/create-an-account`);
    }
  };

  const redirectTo = (url) => {
    window.location.href = url;
  };

  return (
    <>
      <SEO
        title="Instruction | Bowling | BWC Sports"
        description=""
        url="https://bwcsports.com/instruction/bowling"
      />
      <div className="bowling-container">
        <div className="bowling-header filter-brightness">
          <div className="base-sec">
            <div>
              <span className="bowling-backIcon">
                <BackIcon />
              </span>
            </div>
            <div className="bowling-header-content">
              <h1 className="black-text-clip">Bowling</h1>
              <h3 className="black-text-clip">
                Looking to improve your bowling skills?
              </h3>
              <p className="black-text-clip">
                Our expert bowling trainer offers personalized lessons tailored
                to bowlers of all levels. Whether you’re a beginner aiming to
                learn the basics or an experienced player seeking to refine your
                technique, our lessons cover everything from grip and stance to
                advanced strategies and tips. Join us to boost your confidence
                on the lanes, perfect your form, and achieve higher scores.
                Let’s bowl your way to success! Sign up today and start rolling
                strikes!
              </p>
            </div>
          </div>
        </div>
        <div className="bowling-booking-container">
          <button
            className="one-on-one"
            onClick={() => handleSubmit("1-1")}
            // onClick={() =>
            //   redirectTo(
            //     "https://docs.google.com/forms/d/e/1FAIpQLSf2aKPvoOcrVIYCl4Qou3-W4Kd5MhlUQaTJwSlLkKZ8khMWqQ/viewform",
            //   )
            // }
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            onClick={() => handleSubmit("Group")}
            // onClick={() =>
            //   redirectTo(
            //     "https://docs.google.com/forms/d/e/1FAIpQLSf2aKPvoOcrVIYCl4Qou3-W4Kd5MhlUQaTJwSlLkKZ8khMWqQ/viewform",
            //   )
            // }
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule Group Class Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one bowling-booking-selected"
              onClick={() => handleSubmit("")}
              // onClick={() =>
              //   redirectTo(
              //     "https://docs.google.com/forms/d/e/1FAIpQLSf2aKPvoOcrVIYCl4Qou3-W4Kd5MhlUQaTJwSlLkKZ8khMWqQ/viewform",
              //   )
              // }
              style={{ cursor: "pointer" }}
            >
              <span className="black-text-clip">Sign Up for Classes Here</span>
            </button>
          )}
        </div>
        <div className="bowling-image-container">
          <img src={bowling_image1} alt="bowling-image" />
          <img src={bowling_image2} alt="bowling-image" />
          <img src={bowling_image3} alt="bowling-image" />
          <img src={bowling_image4} alt="bowling-image" />
        </div>
        <div className="bowling-section2">
          <h3 className="black-text-clip">Why Choose BWC Bowling?</h3>
          <p className="black-text-clip">
            At BWC Bowling, we offer a range of programs that are as
            comprehensive as they are fun. Our goal is to provide every player
            with the tools they need to succeed, both on and off the lane. Our
            carefully designed drills and games create an environment where
            learning is exciting and improvement is inevitable.
          </p>
          <div className="bowling-section2-image-container">
            <span className="bowling-overlay-text bottom-left bowl-left">
              1-on-1 Training
            </span>
            <span className="bowling-overlay-text top-right bowl-right">
              Group Training
            </span>
            <img src={bowling_section_image} alt="bowling-image-session" />
          </div>
        </div>

        <div className="bowling-section3">
          <h3 className="black-text-clip">Dive into Our Exciting Programs</h3>
          <p className="black-text-clip">
            Our programs are packed with a variety of drills and games designed
            to sharpen your skills and boost your confidence:
          </p>
          <div className="soccer-section3-image-container">
            <div className="sc-card">
              <img src={Bowling21} alt="Stance & Approach" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Stance & Approach</div>
                <div className="sc-card-desc">
                  Develop a consistent stance and approach. Practice proper foot
                  placement, posture, and timing.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Bowling22} alt="Grip & Release" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Grip & Release</div>
                <div className="sc-card-desc">
                  Focus on gripping the ball correctly for a controlled release.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Bowling23} alt="Targeting" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Targeting</div>
                <div className="sc-card-desc">
                  Practice aiming at specific arrows or marks on the lane.
                  Develop precision in aligning your shot.
                </div>
              </div>
            </div>
            <div className="sc-card">
              <img src={Bowling24} alt="Ball Speed & Control" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Ball Speed & Control</div>
                <div className="sc-card-desc">
                  Train to maintain consistent ball speed for accuracy and pin
                  action. Work on adjusting your speed and spin.
                </div>
              </div>
            </div>

            <div className="sc-card">
              <img src={Bowling25} alt="Ball Speed & Controls" />
              <div className="sc-overlay"></div>
              <div className="sc-card-content">
                <div className="sc-card-title">Ball Speed & Control</div>
                <div className="sc-card-desc">
                  Hone your ability to pick up spares by practicing shots for
                  all pin configurations.
                </div>
              </div>
            </div>

            {/* <div className="soccer_section_image_cont"><span className="skill-text-overlay">Passing</span><img src={soccerSkill1} alt="Shooting" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Shooting</span><img src={soccerSkill2} alt="Passing" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Defending</span><img src={soccerSkill3} alt="Defense" /></div>
                        <div className="soccer_section_image_cont"><span className="skill-text-overlay">Goal Keeping</span><img src={soccerSkill4} alt="Rebounding" /></div> */}
          </div>
        </div>
        <div className="bowling-section4">
          <h3 className="black-text-clip">Scrimmages and Games</h3>
          <p className="black-text-clip">
            Practice makes perfect, but nothing beats game day. Our scrimmages
            and games give players the chance to apply what they’ve learned in a
            real-game setting, building confidence and experience. We cater to
            all skill levels, from ages 4 to 18, ensuring that every player
            finds their place on the field.
          </p>
        </div>
        <div className="bowling-booking-container2">
          <div className="bowling-booking-container-details">
            <h3 className="black-text-clip">Ready To Get Started?</h3>
            <p className="black-text-clip">
              Don’t miss out on this incredible opportunity to give your child
              the best start in Bowling. Our spots fill up fast—secure your
              place today!
            </p>
            <p className="black-text-clip">
              <strong>Join the Team Now</strong> – Let’s make this season your
              best one yet!
            </p>
          </div>
          <div className="bowling-booking-container inside-booking-container">
            <button
              className="one-on-one"
              onClick={() => handleSubmit("1-1")}
              style={{ cursor: "pointer" }}
            >
              <span className="black-text-clip">
                Schedule 1-on-1 Class Here
              </span>
            </button>
            <button
              className="one-on-one"
              onClick={() => handleSubmit("Group")}
              // onClick={() =>
              //   redirectTo(
              //     "https://docs.google.com/forms/d/e/1FAIpQLSf2aKPvoOcrVIYCl4Qou3-W4Kd5MhlUQaTJwSlLkKZ8khMWqQ/viewform",
              //   )
              // }
              style={{ cursor: "pointer" }}
            >
              <span className="black-text-clip">Schedule Group Class Here</span>
            </button>
            {!user && (
              <button
                className="one-on-one bowling-booking-selected"
                onClick={() => handleSubmit("")}
                // onClick={() =>
                //   redirectTo(
                //     "https://docs.google.com/forms/d/e/1FAIpQLSf2aKPvoOcrVIYCl4Qou3-W4Kd5MhlUQaTJwSlLkKZ8khMWqQ/viewform",
                //   )
                // }
                style={{ cursor: "pointer" }}
              >
                <span className="black-text-clip">Sign Up for Classes Here</span>
              </button>
            )}
          </div>
        </div>
        <div className="bowling-booking-container outside-booking-container">
          <button
            className="one-on-one"
            onClick={() => handleSubmit("1-1")}
            // onClick={() =>
            //   redirectTo(
            //     "https://docs.google.com/forms/d/e/1FAIpQLSf2aKPvoOcrVIYCl4Qou3-W4Kd5MhlUQaTJwSlLkKZ8khMWqQ/viewform",
            //   )
            // }
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule 1-on-1 Class Here</span>
          </button>
          <button
            className="one-on-one"
            onClick={() => handleSubmit("")}
            // onClick={() =>
            //   redirectTo(
            //     "https://docs.google.com/forms/d/e/1FAIpQLSf2aKPvoOcrVIYCl4Qou3-W4Kd5MhlUQaTJwSlLkKZ8khMWqQ/viewform",
            //   )
            // }
            style={{ cursor: "pointer" }}
          >
            <span className="black-text-clip">Schedule for Classes Here</span>
          </button>
          {!user && (
            <button
              className="one-on-one bowling-booking-selected"
              onClick={() => handleSubmit("")}
              // onClick={() =>
              //   redirectTo(
              //     "https://docs.google.com/forms/d/e/1FAIpQLSf2aKPvoOcrVIYCl4Qou3-W4Kd5MhlUQaTJwSlLkKZ8khMWqQ/viewform",
              //   )
              // }
              style={{ cursor: "pointer" }}
            >
              <span className="black-text-clip">Sign Up for Classes Here</span>
            </button>
          )}
        </div>

        <div className="bowling-trainers">
          <h3 className="black-text-clip">Our Trainers</h3>
          <div className="bowling-trainer-image-container">
            <div className="bowling-trainer-image">
              {/* <div className="skill-text-overlay">
                                <h4>Trainer Name</h4>
                                <p>Trainer Specification</p>
                            </div> */}
              <img src={bowling11} alt="trainer-image" />
            </div>
            <div className="bowling-trainer-image">
              {/* <div className="skill-text-overlay">
                                <h4>Trainer Name</h4>
                                <p>Trainer Specification</p>
                            </div> */}
              <img src={bowling12} alt="trainer-image" />
            </div>
            <div className="bowling-trainer-image">
              {/* <div className="skill-text-overlay">
                                <h4>Trainer Name</h4>
                                <p>Trainer Specification</p>
                            </div> */}
              <img src={bowling13} alt="trainer-image" />
            </div>
          </div>
        </div>
        <div className="bowling-locations">
          <h3 className="black-text-clip">Locations</h3>
          <div className="bowling-location-container">
            <div className="card">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3029.852200979176!2d-74.0889411!3d40.5890177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24ec32dcaae6f%3A0x514ffa9ba000e8e9!2s1600%20Hylan%20Blvd%2C%20Staten%20Island%2C%20NY%2010305%2C%20USA!5e0!3m2!1sen!2sin!4v1773672912098!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
              <div className="card-description black-text-clip">
                <p>
                  <strong>Rab’s Country Lanes</strong>, New York
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
